import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class EnvironmentViewModel {
    Id: number;
    Name: string;
    AirswebCompatible: boolean;
    AirlensCompatible: boolean;
    NoOfApplications: number;
}

export interface AgentViewModel {
    Id: number;
    Name: string;
}

export interface SettingProvider {
    Type: string;
    JsonType: string;
    Id: string;
    Provider: any; 
}

export class EditEnvironmentViewModel {
    Environment: any;
    Agents: AgentViewModel[];
    EditModels: SettingProvider[];
    CanSeeApis: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    private apiUrl = '';  // URL to web api

    constructor(
        private http: HttpClient
    ) { }

    getEnvironments() {
        return this
            .http
            .get<EnvironmentViewModel[]>(this.apiUrl + "/api/environments");
    }

    getConfig(id: number) {
        return this
            .http
            .get<EditEnvironmentViewModel>(`${this.apiUrl}/api/environments/${id}/config`);
    }

    saveConfig(config: any, id:number, canSeeApis: boolean = false) {
        return this
            .http
            .put(`${this.apiUrl}/api/environments/${id}/config?canSeeApis=${canSeeApis}`, JSON.stringify(config));
    }

    private extractEditModel(response: any): EditEnvironmentViewModel {
        const data = response;
        data.Environment = JSON.parse(data.EnvironmentJson);
        return data;
    }
}
